












import { Component, Vue } from 'vue-property-decorator'
import { getFinishRecords } from '@/api/api'
import moment from 'moment'

@Component({})
export default class FinishRecord extends Vue {
  recordList: Array<any> = [] // 学习记录列表
  pageSize: number = 5 // 分页组件的page-size
  total: number = 0 // 分页组件的total

  mounted() {
    this._getFinishRecords()
  }

  /**
   * 换页
   */
  changePage(page: number): void {
    this._getFinishRecords(page)
  }

  /**
   * 接口 用户查询学习记录
   * @param page 页数
   * @param size 每页数量
   */
  _getFinishRecords(page: number = 1, size: number = this.pageSize): void {
    const load = this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    getFinishRecords({ page, size })
      .then((res: any) => {
        load.close()
        console.log(res)
        if (res.data.code === 101) {
          this.recordList = []
          const arr = res.data.result.records
          for (let i = 0, len = arr.length; i < len; i++) {
            this.recordList.push({
              name: arr[i].course_name,
              time: moment(arr[i].finish_time).format('YYYY.MM.DD hh:mm:ss')
            })
          }
          this.total = res.data.result.total
        }
      })
      .catch(_ => {
        load.close()
      })
  }
}
